module.exports = __webpack_public_path__ + "assets/facebook.300715fc.svg";